import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container'

import logo from '../../images/Weblogo.png'
import medium from '../../images/mediumbottom.png'
import telegram from '../../images/telegrambottom.png'
import twitter from '../../images/twitterbottom.png'

const useStyles = makeStyles((theme) => ({
  logo: {
      maxWidth: 120
  },
  dashboardBtn: {
    maxWidth: 23
  },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  links: {
    color: '#fff',
    padding: '0px 8px',
    fontWeight: 700,
    textTransform: 'uppercase',
    '&:hover': {
      color: "#f4f4f4",
      TextDecoder: 'none'
   },
  }
}));

const Menu = () => {
  const classes = useStyles();
  
  return (
    <div className={classes.root + " pb-3"}>
      <div>
        <Typography variant="h6" noWrap className="pl-2 text-light">
          <Link to="/" className={classes.links}>
            <img src={logo} alt="logo" className={classes.logo + " img-fluid"} />
          </Link>
        </Typography>
      </div>
      <div>
        <a href="/#features" className={classes.links + " d-none d-sm-inline-block"}>FEATURES</a>
        <a href="https://github.com/interfinetwork/smart-contract-audits/blob/main/FantomMoon_AuditReport_InterFi.pdf" target="_blank" className={classes.links + " d-none d-sm-inline-block"}>Audit</a>
        <a href="/#tokenomics" className={classes.links + " d-none d-sm-inline-block"}>TOKENOMICS</a>
        <a href="/#roadmap" className={classes.links + " d-none d-sm-inline-block"}>ROADMAP</a>
        <a href="/#faq" className={classes.links + " d-none d-sm-inline-block"}>FAQ's</a>
        <a href="https://fantom-moon.medium.com/" target="_blank" className={classes.links + " d-none d-sm-inline-block"}>WHITEPAPER</a>
        <a href="/locker" className={classes.links + " d-none d-sm-inline-block"}>LOCKER</a>
        <br className="d-md-none" />
        <a href="https://fantom-moon.medium.com/" target="_blank" className={classes.links}>
          <img src={medium} alt="lgo" className={classes.dashboardBtn + " img-fluid"} />
        </a>
        <a href="https://t.me/FANTOMMOON" target="_blank" className={classes.links}>
          <img src={telegram} alt="lgo" className={classes.dashboardBtn + " img-fluid"} />
        </a>
        <a href="https://twitter.com/fantommoon2" target="_blank" className={classes.links}>
          <img src={twitter} alt="lgo" className={classes.dashboardBtn + " img-fluid"} />
        </a>
      </div>
    </div>
  );
}


export default Menu;
